module.exports = __webpack_public_path__ + "static/media/blackarrow.89545bab.svg";